/* The services page frame, as the events page draws its own (EventsGrid.module.css). Colors are theme tokens only. */
@layer telify {
  .crumbs {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 26px 0 0;
    font-size: 13.5px;
    color: var(--text-tertiary);
  }

  .crumbs a {
    cursor: pointer;
  }

  .crumbSep {
    color: var(--text-muted);
  }

  .crumbHere {
    color: var(--text-secondary);
  }

  .head {
    padding-top: 44px;
  }

  /* The rows follow the heading directly, not a home section's spacing. */
  .page > [data-part='section'] {
    margin-top: 8px;
  }

  @media (hover: hover) {
    .crumbs a:hover {
      color: var(--text-primary);
      text-decoration: underline;
      text-underline-offset: 3px;
    }
  }
}
